import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
environment

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor(
    private _HttpClient:HttpClient
  ) { }

  // '/api/content/alexcoc/contact-requests/';



  contactUsForm(body:any):Observable<BaseResponse<any>>{
    return this._HttpClient.post<BaseResponse<any>>(`${environment.serverUrl}/api/content/acer/contactusrequest`,this.handleRequestData(body));
  }

  subscribeForm(body:any):Observable<BaseResponse<any>>{
    return this._HttpClient.post<BaseResponse<any>>(`${environment.serverUrl}/api/content/acer/newsfeed-subscription-requests`,this.handleRequestData(body));
  }

  courseSubscriptionForm(body:any):Observable<BaseResponse<any>>{
    return this._HttpClient.post<BaseResponse<any>>(`${environment.serverUrl}/api/content/acer/course-subscription-requests`,this.handleRequestData(body));
  }

  seminarSubscriptionForm(body:any):Observable<BaseResponse<any>>{
    return this._HttpClient.post<BaseResponse<any>>(`${environment.serverUrl}/api/content/acer/seminar-subscription-requests`,this.handleRequestData(body));
  }

  handleRequestData(requestData: any): any {
    debugger ;

    if (typeof requestData == 'object' && requestData != null) {
      Object.keys(requestData).forEach((propName) => {
        requestData[propName] = { iv: requestData[propName] };
      });
    }
    return requestData;
  }
}

export interface BaseResponse<T> {
  total: number;
  items: BaseResponseItem<T>[];
}

export interface BaseResponseItem<T> {
  id: string;
  createdBy: string;
  lastModifiedBy: string;
  data: T;
  created: Date;
  lastModified: Date;
  statusColor: string;
  isDeleted: boolean;
  version: number;
}







